/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfEntityAdditionalInfosDto } from "../models/AjaxResponseOfEntityAdditionalInfosDto";
import type { AjaxResponseOfInt64 } from "../models/AjaxResponseOfInt64";
import type { AjaxResponseOfListOfEntityAdditionalInfosDto } from "../models/AjaxResponseOfListOfEntityAdditionalInfosDto";
import type { EntityAdditionalInfoCreateDto } from "../models/EntityAdditionalInfoCreateDto";
import type { EntityAdditionalInfoUpdateDto } from "../models/EntityAdditionalInfoUpdateDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class EntityAdditionalInfosAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfEntityAdditionalInfosDto
   * @throws ApiError
   */
  public getAll({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfListOfEntityAdditionalInfosDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entity-management-info/{id}/todos",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfEntityAdditionalInfosDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfEntityAdditionalInfosDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entity-management-info/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/entity-management-info/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfInt64
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: EntityAdditionalInfoCreateDto;
  }): CancelablePromise<AjaxResponseOfInt64> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/entity-management-info",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: EntityAdditionalInfoUpdateDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/entity-management-info",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
